import { render } from "./tab-test-subject.vue?vue&type=template&id=1e87fd18&scoped=true"
import script from "./tab-test-subject.vue?vue&type=script&lang=js"
export * from "./tab-test-subject.vue?vue&type=script&lang=js"

import "./tab-test-subject.vue?vue&type=style&index=0&id=1e87fd18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e87fd18"]])

export default __exports__